export enum StandaloneTankTATEnum {
    LiquidHeight = 121540,
    LiquidStock = 121541,
    CapacityFilled = 121542,
    CapacityRemaining =  121543
}
